// ORGANIZATION_OPTIONS та EORE_ORGANIZATION_OPTIONS використовуються як fallback
// до завантаження динамічних даних з апішки (getOrganizationsRestricted).
//
// Замінено на дані з апішки:
//   - src/pages/Reports/blocks/GeneralInfo/ReportingOrganization.js  (NTS & HA)
//   - src/pages/EORE/Reports/Blocks/Create/GeneralInfo/ReporterOrganization.js  (EORE)
//
// досі захардкодженнл:
//   - src/pages/TaskClearance/Daily/Blocks/DMSBlock/Organization.js  (Daily TCP)

export const ORGANIZATION_OPTIONS = [
  { value: 'FSD', label: 'FSD' },
];

export const EORE_ORGANIZATION_OPTIONS = [
  { value: 'FSD', label: 'FSD' },
  { value: 'uchp', label: 'UCHP' },
];

export const DEFAULT_ORGANIZATION = 'FSD';
